import React, { useEffect, useState } from "react";
import { Table, Container, Button } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";
import { useSelector } from "react-redux";

const AddAmenitiesAndHotelFacilitiesList = (props) => {
  const [dataSet, updateDataSet] = useState([]);
  const data = useSelector((state) => state.adminAccount.apiResponse);
  useEffect(() => {
    (async () => {
      if (props.type == "Amenities") {
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const res = await fetch(
          "https://api.zupptravel.com/api/v1/hotel/getAmenities",
          {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              'Authorization': authHeader
            }
          }
        );
        const json = await res.json();
        console.log(json);
        if (json.success) {
          updateDataSet(json.amenities);
        }
      } else {
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const res = await fetch(
          "https://api.zupptravel.com/api/v1/hotel/getFacilities",
          {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              'Authorization': authHeader
            }
          }
        );

        const json = await res.json();
        console.log(json);
        if (json.success) {
          updateDataSet(json.facilities);
        }
      }
    })();
  }, [props.type]);
  console.log(dataSet);

  // useEffect(() => {
  //   if (props.data != undefined) {
  //     updateDataSet(props.data);
  //   }
  // }, [props.data]);
  const HandleDelete = async (id) => {
    if (props.type == "Amenities") {
      const newd = {
        emailID: data.data.key,
        id: id,
        sessionKey: data.sessionId,
      };
      console.log(newd);
      const r = await fetch("https://api.zupptravel.com/deleteHotelAmenities", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newd),
      });
      const j = await r.json();
      if (j.successful) {
        alert("Successfully deleted amenity");
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const res = await fetch(
          "https://api.zupptravel.com/api/v1/hotel/getAmenities",
          {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              'Authorization': authHeader
            }
          }
        );
        const json = await res.json();
        if (json.success) {
          updateDataSet(json.amenities);
        }
      }
    } else {
      const newd = {
        emailID: "string",
        id: id,
        sessionKey: "string",
      };
      const r = await fetch(
        "https://api.zupptravel.com/deleteHotelFacilities",
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newd),
        }
      );
      const j = await r.json();
      if (j.successful) {
        alert("Successfully deleted facility");
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const res = await fetch(
          "https://api.zupptravel.com/api/v1/hotel/getFacilities",
          {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              'Authorization': authHeader
            }
          }
        );
        const json = await res.json();
        if (json.success) {
          updateDataSet(json.facilities);
        }
      }
    }
  };

  console.log(props);

  return (
    <Container fluid style={{ padding: "0" }}>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>S.No</th>
            <th>{props.type}</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {dataSet?.length > 0
            ? dataSet.map((data, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{data[props.type.toLowerCase()]}</td>
                  <td className={classes.CenterRow}>
                    <Button
                      style={{ margin: "auto 1%" }}
                      variant="danger"
                      onClick={() => HandleDelete(data.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </Table>
    </Container>
  );
};
export default AddAmenitiesAndHotelFacilitiesList;
